import * as React from 'react';
import {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {RoutePath} from "../../../../../constants/RoutePath";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {FormattedMessage, useIntl} from "react-intl";
import HomeIcon from "@mui/icons-material/Home";
import NavigationBar from "../../../../../components/NavigationBar";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import RequestDetailCard from "./components/RequestDetailCard";
import {HttpUtils} from "../../../../../utils/HttpUtils";
import {UserApi} from "../../../../../modules/account/api/UserApi";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {AuthType} from "../../../../../modules/account/enums/AuthType";
import {WECHAT_APP_ID, WECHAT_AUTH_DOMAIN, WECHAT_AUTH_PAGE} from "../../../../../constants/Profile";

export default function Index() {
    const intl = useIntl();
    const navigate = useNavigate();

    const [pendingApproves, setPendingApproves] = useState<Array<VisitRequestDto>>([]);

    useEffect(() => {
        // 微信网页授权会携带code，然后通过后台获取openID，提交的时候把该openID跟访客绑定
        const wxOAuthCode = HttpUtils.getQueryString(window.location.href, "wxOAuthCode");
        if (wxOAuthCode) {
            _loginByWeChatAuthCode(wxOAuthCode);
        } else {
            // 查询用户组列表
            _fetchVisitRequestList();
        }
    }, []);

    const _loginByWeChatAuthCode = async (wxOAuthCode: string) => {
        const responseResult = await UserApi.login(new UserDto(), AuthType.Enum.WeChatOAuth, wxOAuthCode);
        if (responseResult.status === HttpStatus.SUCCESS) {
            _fetchVisitRequestList();
        } else {
            const redirectUri = encodeURIComponent(WECHAT_AUTH_DOMAIN + "/" + WECHAT_AUTH_PAGE);
            const state = encodeURIComponent(RoutePath.VMS_MOBILE_EMPLOYEE_LOGIN);
            // navigate(RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER)
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WECHAT_APP_ID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
        }
    }

    const _fetchVisitRequestList = async () => {
        const responseResult = await VisitRequestApi.getPendingApprovalList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setPendingApproves(responseResult.data);
        }
    };

    return (
        <div>
            <NavigationBar leftIcon={<HomeIcon/>}
                           leftIconClick={() => navigate(RoutePath.VMS_MOBILE_WELCOME)}
                           title={intl.formatMessage({id: "VMS_VISIT_REQUEST_PENDING_APPROVAL_LIST"})}/>
            <div style={{padding: "1rem"}}>
                {
                    pendingApproves.map((request, index) => {
                        return (
                            <div key={index} style={{marginBottom: "1rem"}}>
                                <RequestDetailCard visitRequest={request} onRefresh={() => _fetchVisitRequestList()}/>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}